function parseJsonRecursively(value: string): unknown | null {
  try {
    let parsed: unknown = JSON.parse(value);
    while (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }
    return parsed;
  } catch {
    return null;
  }
}

export function parseMaintenanceList(raw: unknown): any[] {
  if (raw == null || raw === '') return [];

  let data: unknown = raw;
  if (typeof data === 'string' || data instanceof String) {
    data = parseJsonRecursively(String(data));
    if (data == null) return [];
  }

  return Array.isArray(data) ? data : [];
}

export function serializeMaintenanceList(entries: unknown): string {
  return JSON.stringify(parseMaintenanceList(entries));
}

export function needsMaintenanceListNormalization(raw: unknown): boolean {
  if (typeof raw !== 'string') return false;
  const parsed = parseMaintenanceList(raw);
  if (parsed.length === 0) return false;
  return serializeMaintenanceList(raw) !== raw;
}
